// extracted by mini-css-extract-plugin
var _1 = "webpack-containers-Extraction-ReuseTemplateModal-module__LoadingContainer";
export { _1 as "LoadingContainer" }
